import { WebAnalyticsEvent, WebAnalyticsEventName } from 'hydra-data-types';
import { AiLoadingScreenConfig } from '../components/flows/AiLoadingScreen';
import { AuthScreenConfig } from '../components/flows/AuthScreen';
import { ClassifyScreenConfig } from '../components/flows/ClassifyScreen';
import { DateOfBirthScreenConfig } from '../components/flows/DateOfBirthScreen';
import { DownloadAppScreenConfig } from '../components/flows/DownloadAppScreen';
import { DropdownSelectScreenConfig } from '../components/flows/DropdownSelectScreen';
import { ExpectationSettingScreenConfig } from '../components/flows/ExpectationSettingScreen';
import { ExternalLinkScreenConfig } from '../components/flows/ExternalLinkScreen';
import { FinishAccountScreenConfig } from '../components/flows/FinishAccountScreen';
import { FlowRoute } from '../components/flows/FlowNavigation';
import { HcpReferredScreenConfig } from '../components/flows/HcpReferredScreen';
import { InsuranceProviderScreenConfig } from '../components/flows/InsuranceProviderScreen';
import { LoadingResultsScreenConfig } from '../components/flows/LoadingResultsScreen';
import { MoneyBackGuaranteeScreenConfig } from '../components/flows/MoneyBackGuaranteeScreen';
import { MultiSelectScreenConfig } from '../components/flows/MultiSelectScreen';
import { NumberedSingleSelectScreenConfig } from '../components/flows/NumberedSingleSelectScreen';
import { PaymentScreenConfig } from '../components/flows/PaymentScreen';
import { PhoneNumberScreenConfig } from '../components/flows/PhoneNumberScreen';
import { PresentationScreenConfig } from '../components/flows/PresentationScreen';
import { ProgramBenefitsScreenConfig } from '../components/flows/ProgramBenefitsScreen';
import { ProgramExperienceScreenConfig } from '../components/flows/ProgramExperienceScreen';
import { ProgramOverviewScreenConfig } from '../components/flows/ProgramOverviewScreen';
import { ProgramStructureScreenConfig } from '../components/flows/ProgramStructureScreen';
import { ReferralScreenConfig } from '../components/flows/ReferralScreen';
import { ResultsScreenConfig } from '../components/flows/ResultsScreen';
import { ScreenshotScreenConfig } from '../components/flows/ScreenshotScreen';
import { ShareLinkScreenConfig } from '../components/flows/ShareLinkScreen';
import { SingleSelectScreenConfig } from '../components/flows/SingleSelectScreen';
import { SocialProofScreenConfig } from '../components/flows/SocialProofScreen';
import { TrialExplanationScreenConfig } from '../components/flows/TrialExplanationScreen';
import { UserInfoRecapScreenConfig } from '../components/flows/UserInfoRecapScreen';
import { CoverageAddressScreenConfig } from '../components/flows/coverage/CoverageAddressScreen';
import { CoverageConsentsScreenConfig } from '../components/flows/coverage/CoverageConsentsScreen';
import { CoverageEmployerScreenConfig } from '../components/flows/coverage/CoverageEmployerScreen';
import { CoverageResultsScreenConfig } from '../components/flows/coverage/CoverageResultsScreen';
import { PartnerInsurerAccessScreenConfig } from '../components/flows/coverage/PartnerInsurerAccessScreen';
import { MedicareAccessCoverageLoadingScreenConfig } from '../components/flows/medicareAccess/MedicareAccessCoverageLoadingScreen';
import { MedicareAccessHelplinesScreenConfig } from '../components/flows/medicareAccess/MedicareAccessHelplines';
import { MedicareAccessSafetyCheckScreenConfig } from '../components/flows/medicareAccess/MedicareAccessSafetyCheckScreen';
import { MedicareAccessMbiScreenConfig } from '../components/flows/medicareAccess/MedicareAccessMbiScreen';
import { PapDiscountResultScreenConfig } from '../components/flows/patientAssistance/PapDiscountResultScreen';
import { PapHouseholdIncomeScreenConfig } from '../components/flows/patientAssistance/PapHouseholdIncomeScreen';
import { PapPublicAssistanceScreenConfig } from '../components/flows/patientAssistance/PapPublicAssistanceScreen';
import { Us65PlusGrantAccessScreenConfig } from '../components/flows/us65Plus/Us65PlusGrantAccessScreen';
import { WorksBestScreenConfig } from '../components/trial/WorksBestScreen';
import { HypnotisabilityResultsScreenConfig } from './../components/flows/HypnotisabilityResultsScreen';
import { SingleInputScreenConfig } from './../components/flows/SingleInputScreen';
import { MenoAssessmentScreen } from './meno/MenoConfig';
import { NervaControlScreen } from './nerva/NervaControl';
import { PainControlAssessmentScreen } from './pain/PainControlConfig';
import { QuitAssessmentScreen } from './quit/QuitConfig';

export enum SharedScreenName {
  Payment = 'payment',
  PhoneNumber = 'phoneNumber',
  FinishAccount = 'finishAccount',
  Welcome = 'welcome',
  Name = 'name',
  TrialExplanation = 'trialExplanation',
  ProgramBenefits = 'programBenefits',
  ProgramSupport = 'programSupport',
  Login = 'login',
  Auth = 'auth',
  AlreadyPaidDownloadApp = 'alreadyPaidDownloadApp',
  DownloadApp = 'downloadApp',
  Results = 'results',
  AffectLife = 'affectLife',
  LoadingResults = 'loadingResults',
  Age = 'age',
  DateOfBirth = 'dateOfBirth',
  Gender = 'gender',
  Classify = 'classify',
  Attribution = 'attribution',
  Doctor = 'doctor',
  DoctorReferral = 'doctorReferral',
  NoDoctorReferral = 'noDoctorReferral',
  Treatments = 'treatments',
  ProgramStructure = 'programStructure',
  CoreProgramExperience = 'coreProgramExperience',
  MaintenanceExperience = 'maintenanceExperience',
  WorksBest = 'worksBest',
  HealthIssues = 'healthIssues',
  GIHealthIssues = 'giHealthIssues',
  UserInfoRecap = 'userInfoRecap',
  HypnotisabilityInfo = 'hypnotisabilityInfo',
  HypnotisabilityVividRecall = 'hypnotisabilityVividRecall',
  HypnotisabilityFocus = 'hypnotisabilityFocus',
  HypnotisabilityAbsorption = 'hypnotisabilityAbsorption',
  HypnotisabilityIntuition = 'hypnotisabilityIntuition',
  HypnotisabilityColorVisualization = 'hypnotisabilityColorVisualization',
  HypnotisabilityResults = 'hypnotisabilityResults',
  Referral = 'referral',
  ShareLink = 'shareLink',
  HowLong = 'howLong',
  PatientPhoneNum = 'patientPhoneNum',
  QualityOfLife = 'qualityOfLife',
}

export enum PapScreenName {
  PapPublicAssistance = 'papPublicAssistance',
  PapHouseholdIncome = 'papHouseholdIncome',
  PapHardshipFactors = 'papHardshipFactors',
  PapAffordability = 'papAffordability',
  PapAttestation = 'papAttestation',
  PapDiscountResult = 'papDiscountResult',
}

export enum MedicareAccessScreenName {
  MedicareAccessHealthCover = 'medicareAccessHealthCover',
  MedicareAccessDirectHealthCover = 'medicareAccessDirectHealthCover',
  /** US state of residence, asked right after an Original Medicare answer to gate CMS ACCESS. */
  MedicareAccessState = 'medicareAccessState',
  /**
   * The same question in the under-65 coverage flow, asked only when the address wasn't found (the
   * address state is used otherwise). A separate screen because Control asks MedicareAccessState
   * before sign-up and the coverage flow runs after it.
   */
  MedicareAccessStateNoAddress = 'medicareAccessStateNoAddress',
  MedicareAccessMBI = 'medicareAccessMBI',
  MedicareAccessAdvantageProvider = 'medicareAccessAdvantageProvider',
  MedicareAccessExclusion = 'medicareAccessExclusion',
  MedicareAccessHelplinesUrgent = 'medicareAccessHelplinesUrgent',
  MedicareAccessSuicideCheck = 'medicareAccessSuicideCheck',
  MedicareAccessHarmOthersCheck = 'medicareAccessHarmOthersCheck',
  MedicareAccessDisclosure = 'medicareAccessDisclosure',
  MedicareAccessControl = 'medicareAccessControl',
  MedicareAccessInsurerNotCovered = 'medicareAccessInsurerNotCovered',
  MedicareAccessConsent = 'medicareAccessConsent',
  MedicareAccessOriginalQualified = 'medicareAccessOriginalQualified',
  MedicareAccessAdvantageQualified = 'medicareAccessAdvantageQualified',
  MedicareAccessExpectationSetting = 'medicareAccessExpectationSetting',
  MedicareAccessFreeAccess = 'medicareAccessFreeAccess',
  MedicareAccessCoverageLoading = 'medicareAccessCoverageLoading',
  MedicareAccessResults = 'medicareAccessResults',
}

/**
 * US under-65 (MIS-1) and AU (MIS-177) insurance coverage flows, shown after the insurance-provider
 * dropdown. Screens live in `src/config/nerva/CoverageConfig.ts`; the screen names are also the
 * `user_data` keys.
 */
export enum CoverageScreenName {
  CoveragePlanType = 'coveragePlanType',
  CoverageUsEmployer = 'coverageUsEmployer',
  CoverageBenefits = 'coverageBenefits',
  CoverageAddress = 'coverageAddress',
  CoverageMemberId = 'coverageMemberId',
  /** Navigation only: the answers are saved under the consent keys (`getCoverageConsentsUserData`). */
  CoverageConsents = 'coverageConsents',
  /** Navigation only: a timed loader between the consents and the result. */
  CoverageLoading = 'coverageLoading',
  CoverageResults = 'coverageResults',
  UsedPartnerInsurance = 'usedPartnerInsurance',
}

export enum Us65PlusScreenName {
  Us65PlusCoverageLoading = 'us65PlusCoverageLoading',
}

export enum GAD7ScreenName {
  // Because screen names are used as keys in the DB, dot notation is used for nested object.
  Gad7Nervous = 'gad7.nervous',
  Gad7StopWorrying = 'gad7.stopWorrying',
  Gad7WorryTooMuch = 'gad7.worryTooMuch',
  Gad7TroubleRelaxing = 'gad7.troubleRelaxing',
  Gad7Restless = 'gad7.restless',
  Gad7Annoyed = 'gad7.annoyed',
  Gad7Afraid = 'gad7.afraid',
}

export enum PHQ9ScreenName {
  // Because screen names are used as keys in the DB, dot notation is used for nested object.
  Phq9LittleInterest = 'phq9.littleInterest',
  Phq9FeelingDown = 'phq9.feelingDown',
  Phq9TroubleSleeping = 'phq9.troubleSleeping',
  Phq9FeelingTired = 'phq9.feelingTired',
  Phq9PoorAppetite = 'phq9.poorAppetite',
  Phq9FeelingBad = 'phq9.feelingBad',
  Phq9TroubleConcentrating = 'phq9.troubleConcentrating',
  Phq9SlowOrFast = 'phq9.slowOrFast',
  Phq9SelfHarm = 'phq9.selfHarm',
  // Safety screening, not a scored PHQ-9 item. Kept out of the PROMs symptom diary and the
  // proms-complete count in MedicareAccessSymptomUtils (see PHQ9_PROMS_SCREEN_NAMES).
  Phq9HarmOthers = 'phq9.harmOthers',
}

export enum ScreenType {
  PhoneNumber,
  Presentation,
  SingleSelect,
  SingleInput,
  MultiSelect,
  Screenshot,
  Classify,
  LoadingResults,
  Results,
  ProgramStructure,
  ProgramBenefits,
  TrialExplanation,
  Payment,
  FinishAccount,
  Auth,
  DownloadApp,
  UserInfoRecap,
  SocialProof,
  WorksBest,
  ProgramExperience,
  HypnotisabilityResults,
  Referral,
  ShareLink,
  ExternalLink,
  DateOfBirth,
  HcpReferred,
  AiLoading,
  MoneyBackGuarantee,
  InsuranceProvider,
  ProgramOverview,
  PapPublicAssistance,
  PapHouseholdIncome,
  PapDiscountResult,
  MedicareAccessHelplines,
  MedicareAccessMbi,
  Us65PlusGrantAccess,
  NumberedSingleSelect,
  ExpectationSetting,
  MedicareAccessCoverageLoading,
  MedicareAccessSafetyCheck,
  CoverageEmployer,
  CoverageAddress,
  CoverageResults,
  DropdownSelect,
  PartnerInsurerAccess,
  CoverageConsents,
}

export type ScreenConfig<ScreenNames extends string> =
  | PhoneNumberScreenConfig<ScreenNames>
  | SingleSelectScreenConfig<ScreenNames>
  | SingleInputScreenConfig<ScreenNames>
  | MultiSelectScreenConfig<ScreenNames>
  | ClassifyScreenConfig<ScreenNames>
  | PresentationScreenConfig<ScreenNames>
  | ScreenshotScreenConfig<ScreenNames>
  | LoadingResultsScreenConfig<ScreenNames>
  | ResultsScreenConfig<ScreenNames>
  | ProgramStructureScreenConfig<ScreenNames>
  | TrialExplanationScreenConfig<ScreenNames>
  | ProgramBenefitsScreenConfig<ScreenNames>
  | PaymentScreenConfig<ScreenNames>
  | FinishAccountScreenConfig<ScreenNames>
  | AuthScreenConfig<ScreenNames>
  | DownloadAppScreenConfig<ScreenNames>
  | UserInfoRecapScreenConfig<ScreenNames>
  | SocialProofScreenConfig<ScreenNames>
  | WorksBestScreenConfig<ScreenNames>
  | ProgramExperienceScreenConfig<ScreenNames>
  | HypnotisabilityResultsScreenConfig<ScreenNames>
  | ReferralScreenConfig<ScreenNames>
  | ShareLinkScreenConfig<ScreenNames>
  | ExternalLinkScreenConfig<ScreenNames>
  | DateOfBirthScreenConfig<ScreenNames>
  | HcpReferredScreenConfig<ScreenNames>
  | MoneyBackGuaranteeScreenConfig<ScreenNames>
  | AiLoadingScreenConfig<ScreenNames>
  | InsuranceProviderScreenConfig<ScreenNames>
  | ProgramOverviewScreenConfig<ScreenNames>
  | PapPublicAssistanceScreenConfig<ScreenNames>
  | PapHouseholdIncomeScreenConfig<ScreenNames>
  | PapDiscountResultScreenConfig<ScreenNames>
  | MedicareAccessHelplinesScreenConfig<ScreenNames>
  | MedicareAccessMbiScreenConfig<ScreenNames>
  | MedicareAccessCoverageLoadingScreenConfig<ScreenNames>
  | MedicareAccessSafetyCheckScreenConfig<ScreenNames>
  | Us65PlusGrantAccessScreenConfig<ScreenNames>
  | NumberedSingleSelectScreenConfig<ScreenNames>
  | ExpectationSettingScreenConfig<ScreenNames>
  | CoverageEmployerScreenConfig<ScreenNames>
  | CoverageAddressScreenConfig<ScreenNames>
  | CoverageResultsScreenConfig<ScreenNames>
  | DropdownSelectScreenConfig<ScreenNames>
  | PartnerInsurerAccessScreenConfig<ScreenNames>
  | CoverageConsentsScreenConfig<ScreenNames>;

export type SpinnerOverlayConfig = {
  durationMs: number;
  showWhen?: (selection: string) => boolean;
};

/** `Outcome` is the keys the screen reports to `next`; see `FlowRoute`. */
export type ScreenConfigBase<
  Type extends ScreenType,
  ScreenNames extends string,
  Outcome extends string = never,
> = {
  screenName: ScreenNames;
  type: Type;
  showHeaderBar?: boolean;
  showProgressBar?: boolean;
  backdropColor?: string;
  spinnerOverlay?: SpinnerOverlayConfig;
  /** Clears the page history when the user lands on this screen, so they cannot navigate back past
   * it (e.g. to stop answers being changed once an outcome has been shown). */
  resetHistoryOnEntry?: boolean;
  /** The route is decided by earlier answers, so the progress bar measures the remaining path along
   * it rather than the longest branch (which would leave users not taking a long branch with a big
   * jump once they leave this screen). */
  progressFollowsRoute?: boolean;
} & FlowRoute<ScreenNames, Outcome>;

export type LayoutScreenConfig<
  Type extends ScreenType,
  LayoutConfig,
  ScreenNames extends string,
  Outcome extends string = never,
> = ScreenConfigBase<Type, ScreenNames, Outcome> & {
  layout: LayoutConfig;
};

export type SelectScreenConfig<
  Type extends ScreenType,
  LayoutConfig,
  ScreenNames extends string,
> = LayoutScreenConfig<Type, LayoutConfig, ScreenNames>;

type FlowStartEvent = Extract<WebAnalyticsEvent, { event: WebAnalyticsEventName.o_flow_entered }>;

export type FlowConfig<ScreenNames extends string> = {
  name: string;
  screens: Array<ScreenConfig<ScreenNames>>;
  showProgressBar: boolean;
  startEvent?: FlowStartEvent;
};

export type AssessmentScreen =
  | MenoAssessmentScreen
  | QuitAssessmentScreen
  | NervaControlScreen
  | PainControlAssessmentScreen;
